import { useSnackbar } from "notistack";

let useSnackbarRef;
export const SnackbarUtilsConfigurator = () => {
  useSnackbarRef = useSnackbar();
  return null;
};

export default {
  toast(msg, variant = "default") {
    if (!useSnackbarRef) return;
    useSnackbarRef.enqueueSnackbar(msg, {
      variant,
      anchorOrigin: { vertical: "top", horizontal: "right" },
      autoHideDuration: 6000,
    });
  },
};
